export default __webpack_public_path__ + "assets/images/6af747c63180290557f6d8723d7c5561.png";